import {SHIFT_LENGTH_MAX_HRS} from './staticConfigs';
import {LBL_TERMS_AND_CONDITIONS,LBL_EVENT,LBL_EVENTS,LBL_APP_NAME} from './labelConfigs';
import { userGroupUrlCheck} from '../utils/userGroupUrlCheck';
import {format as stringFormat} from 'react-string-format';
let userGroupData = userGroupUrlCheck(window.location);
let lblCrew = 'Staff'
if(userGroupData!==undefined){
	if(userGroupData.staff_name){
		lblCrew = userGroupData.staff_name; 
	}
}

// ANY TEXT CHANGE IN THIS FILE (msgConfigs.js) ALSO CROSS CHECKED WITH (labelConfigs.js)

export const MSG_AUTHENTICATION_INVALID = "Invalid username or password.";
export const MSG_NETWORK_ERROR          = "Network Error! Try again later!";
export const MSG_USERNAME_REQUIRED      = 'Required';  
export const MSG_PASSWORD_REQUIRED      = 'Required';  
export const MSG_PWDCONFIRM_REQUIRED    = 'Required';  
export const MSG_AFFILIATE_REQUIRED     = 'Required';  
export const MSG_PASSWORD_MISMATCH      = "New passwords are not matching.";
export const MSG_CURR_PASSWORD_REQUIRED = 'Required';  
export const MSG_NEW_PASSWORD_REQUIRED  = 'Required';  
export const MSG_NEW_PWDCONFIRM_REQUIRED= 'Required';  
export const MSG_CURR_NEW_PWD_SAME      = "Current password and new password are the same.";
export const MSG_CHANGE_PASSWORD_SUCCESS= "Your password has been changed successfully. Please relogin.";
export const MSG_CHANGE_PASSWORD_ERROR  = "Password change failed.";

export const MSG_SKILL_REQUIRED             = 'Required'; 
export const MSG_SKILL_DOC_REQUIRED         = 'Required';  
export const MSG_SKILL_ADD_SUCCESS          = "Skill added"; 
export const MSG_SKILL_ADD_ERROR            = "Skill adding failed"; 
export const MSG_SKILL_UPDATE_SUCCESS       = "Skill updated.";
export const MSG_SKILL_SAVE_SUCCESS         = "Skill updated.";
export const MSG_SKILL_DELETE_SUCCESS       = "Skill deleted.";
export const MSG_SKILL_SAVE_ERROR           = "Skill field is empty.";
export const MSG_SKILL_DUP_ERROR            = "This skill is already added.";

export const MSG_SKILL_BASEPRATE_REQUIRED   = 'Required';  
export const MSG_SKILL_CHARGERATE_REQUIRED  = 'Required';  

export const MSG_ERROR                  = "Internal server error!";
export const MSG_REQUIRED               = "Required ";
export const MSG_DUPLICATION            = "This email already exists.";
export const MSG_EMAIL_DUPLICATION      = "The following emails already exists:";

export const MSG_DECIMAL_NUM_ERROR      = "The value must be a decimal number.";
export const MSG_NOT_VALID_ERROR        = "A valid value is required.";

export const MSG_SECTOR_REQUIRED         = 'Required';  
export const MSG_SECTOR_ADD_SUCCESS      = "Sector added.";
export const MSG_SECTOR_UPDATE_SUCCESS   = "Sector updated.";
export const MSG_SECTOR_DELETE_SUCCESS   = "Sector deleted.";

export const MSG_ROLES_REQUIRED          = 'Required';  
export const MSG_ROLES_ADD_SUCCESS       = "Role added";
export const MSG_ROLES_UPDATE_SUCCESS    = "Role updated.";
export const MSG_ROLES_DELETE_SUCCESS    = "Role deleted.";
export const MSG_ROLES_PERMISSION_SUCCESS= "Permission updated.";
export const MSG_ROLES_ADD_EDIT_DUPLICATE= "Role name already exists.";

export const MSG_SUBSECTOR_REQUIRED         = 'Required';  
export const MSG_SUBSECTOR_ADD_SUCCESS      = "Sub sector Added";
export const MSG_SUBSECTOR_UPDATE_SUCCESS   = "Sub sector updated";
export const MSG_SUBSECTOR_DELETE_SUCCESS   = "Sub sector deleted";

export const MSG_OTHER_EXP_REQUIRED         = 'Required';  
export const MSG_OTHER_EXP_ADD_SUCCESS      = "Other expenses added.";
export const MSG_OTHER_EXP_UPDATE_SUCCESS   = "Other expenses updated.";
export const MSG_OTHER_EXP_DELETE_SUCCESS   = "Other expenses deleted.";
export const MSG_OTHER_EXP_USED   			= "This other expense already used.";
export const MSG_OTHER_SAVE_FAILED   		= "Other expenses data saving failed.";

export const MSG_CLIENT_CATEGORY_REQUIRED         = 'Required';  
export const MSG_CLIENT_CATEGORY_ADD_SUCCESS      = "Client category added.";
export const MSG_CLIENT_CATEGORY_UPDATE_SUCCESS   = "Client category updated.";
export const MSG_CLIENT_CATEGORY_DELETE_SUCCESS   = "Client category deleted.";
export const MSG_CATEGORY_DUP_ERROR               = "This category is already added.";

export const MSG_USER_DOC_REQUIRED            = 'Required';  
export const MSG_USER_DOC_ADD_SUCCESS         = "Document added.";
export const MSG_USER_DOC_UPDATE_SUCCESS      = "Document updated.";
export const MSG_USER_DOC_DELETE_SUCCESS      = "Document deleted.";

export const MSG_PP_POINTS_SUCCESS            = "Performance points updated!";
export const MSG_OMNU_ERROR                   = "Points cannot be empty.";
export const MSG_PP_POINT_EXISTS              = "PP up to value already exists.";

export const MSG_PROF_CMPNY_INFO_ADD    = "Company info saved";
export const MSG_PROF_ADDRESS_UPDATE    = "Address saved";
export const MSG_PROF_PRMY_CNT_ADD      = "Primary contact saved. We have sent the confirmation email to the given email address. In order to complete the registration process, please click the confirmation link.";
export const MSG_PROF_PRMY_CNT_UPDATE   = "Primary contact saved.";
export const MSG_PROF_SETTINGS_UPDATE   = "Settings saved";
export const MSG_URL_ERROR              = "No more than 32 characters allowed.";
export const MSG_TRAVEL_MODULE_FIELDS_ERROR = 'Please choose field(s) for travel cost calculations'; 

export const MSG_APPAYRATE_CATEGORY_REQUIRED    = "Required";  
export const MSG_APPAYRATE_FROM_REQUIRED        = "Required";  
export const MSG_APPAYRATE_TO_REQUIRED          = "Required";  
export const MSG_APPAYRATE_RATE_REQUIRED        = "Required"; 
export const MSG_APPAYRATE_ADD_SUCCESS          = "AP pay rate added.";
export const MSG_APPAYRATE_UPDATE_SUCCESS       = "AP pay rate updated.";
export const MSG_APPAYRATE_DELETE_SUCCESS       = "AP pay rate deleted.";
export const MSG_APPAYRATE_ADD_EDIT_DUPLICATE   = "Incorrect value for AP from or AP to.";  
export const MSG_APPAYRATE_MISMATCH             = "Incorrect value for AP from or AP to.";
export const MSG_APCATEGORY_ADD_EDIT_DUPLICATE  = "AP category already exists.";  

export const MSG_QUOTE_DOWNLOAD_ERROR        = 'Quote download failed.';
export const MSG_INVOICE_DOWNLOAD_ERROR      = 'Invoice has not generated for this '+LBL_EVENT.toLowerCase()+' yet.';
export const MSG_INVOICE_GENERATION_SUCCESS  = 'Invoice generated successfully.';
export const MSG_INVOICE_GENERATION_ERROR    = 'Invoice generation failed.';

export const MSG_NOT_FOUND                      = 'No records found.'; 
export const MSG_AFFILIATE_DELETE               = "Affiliate deleted";

export const MSG_STCBONUS_SKILL_REQUIRED       = 'Required';  
export const MSG_STCBONUS_HOUR_REQUIRED        = 'Required';  
export const MSG_STCBONUS_RATE_REQUIRED        = 'Required';  
export const MSG_STCBONUS_ADD_SUCCESS          = "Short term call bonus added.";
export const MSG_STCBONUS_UPDATE_SUCCESS       = "Short term call bonus updated.";
export const MSG_STCBONUS_DELETE_SUCCESS       = "Short term call bonus deleted.";
export const MSG_STCBONUS_ADD_EDIT_DUPLICATE   = "Short term call bonus already exists.";

export const MSG_LOC_ADDED                     = "Location added.";
export const MSG_LOC_DELETE                    = "Location deleted.";

export const MSG_KEY_LOCATION_REQUIRED         = "Please select key location.";  
export const MSG_DEPARTMENT_REQUIRED           = 'Required';  
export const MSG_DEPARTMENT_ADD_SUCCESS        = "Department added.";
export const MSG_DEPARTMENT_UPDATE_SUCCESS     = "Department updated.";
export const MSG_DEPARTMENT_DELETE_SUCCESS     = "Department deleted.";
export const MSG_DEPARTMENT_ADD_EDIT_DUPLICATE = "Department already exists.";

export const MSG_RATECARD_REQUIRED           = 'Required';  
export const MSG_RATECARD_ADD_SUCCESS        = "Rate Card added.";
export const MSG_RATECARD_UPDATE_SUCCESS     = "Rate Card updated.";
export const MSG_RATECARD_DELETE_SUCCESS     = "Rate Card deleted.";
export const MSG_RATECARD_ADD_EDIT_DUPLICATE = "Rate Card already exists.";

export const MSG_LOC_IMPORT                    = "Location(s) imported successfully.";
export const MSG_ALREADY_LOC_IMPORTED          = "All the locations in this file has been already imported.";

export const MSG_MASTER_RATE_CARD_UPDATE_SUCCESS="Master rate card  updated.";
export const MSG_MASTER_RATE_CARD_UPDATE_ERROR = "Master rate card updation failed.";

export const MSG_PAYRATE_REQUIRED       = 'Required';  
export const MSG_CHARGERATE_REQUIRED    = 'Required';  
export const MSG_RATE_MISMATCH          = "Incorrect value for pay rate or charge rate."; 

export const MSG_CLIENT_DELETE                   = "Client deleted.";
export const MSG_CLIENT_ACTIVATED                = "Client activated.";
export const MSG_CLIENT_ADD_SUCCESS              = "New client added. We have sent a confirmation link to the email address given. To complete the registration process, please click the confirmation link.";
export const MSG_NO_VERIFICATION_CLIENT_ADD_SUCCESS = "New client details added successfully.";
export const MSG_DEACTIVATED                     = "has been deactivated";
export const MSG_ACTIVATED                       = "has been activated";
export const MSG_DELETED                         = "has been deleted";
export const MSG_CLIENT_INFO_SAVE                = "Client basic info saved.";
export const MSG_CLIENT_INFO_UPDATE              = "Client basic info updated.";
export const MSG_CLIENT_CNCT_SAVE_NO_EMAIL       = "Primary contact saved.";
export const MSG_CLIENT_CNCT_SAVE                = "Primary contact saved. We have sent a confirmation link to the email address given. To complete the registration process, please click the confirmation link.";
export const MSG_CLIENT_CNCT_UPDATE              = "Primary contact updated.";
export const MSG_CLIENT_CNCT_SEND_MAIL           = "Contact details updated. We have sent a confirmation link to the email address given. To complete the registration process, please click the confirmation link.";
export const MSG_CLIENT_IMPORT_SUCCESS            = "Client data imported successfully."

export const MSG_CREW_INFO_SAVE_NO_EMAIL         = stringFormat("{0} basic info saved.",lblCrew);
export const MSG_CREW_INFO_SAVE                  = stringFormat("{0} basic info saved. We have sent a confirmation link to the email address given. To complete the registration process, please click the confirmation link.",lblCrew);
export const MSG_CREW_INFO_UPDATE                = stringFormat("{0} basic Info updated.",lblCrew);
export const MSG_CREW_DELETED                    = "has been deactivated.";

export const MSG_CLIENT_CNCT_DETAILS_ADD         = "Contact details added.";
export const MSG_CLIENT_CNCT_DETAILS_UPDATE      = "Contact details updated.";
export const MSG_CLIENT_CNCT_DETAILS_DELETE      = "Contact details deleted.";

export const MSG_CREW_DELETE                     = stringFormat("{0} deleted",lblCrew);

export const MSG_DYNAMIC_FIELD_NAME_REQUIRED        = 'Required'; 
export const MSG_DYNAMIC_FIELD_TYPE_REQUIRED        = 'Required';
export const MSG_DYNAMIC_FIELD_TYPE_UPDATE_SUCCESS  = "Dynamic fields updated.";
export const MSG_DYNAMIC_FIELD_TYPE_UPDATE_ERROR    = "Dynamic fields updation failed.";
export const MSG_DYNAMIC_FIELD_REQUIRED             = 'Required';  
export const MSG_DYNAMIC_FIELD_DATA_SAVE_SUCCESS    = 'Details updated.';  
export const MSG_DYNAMIC_FIELD_DATA_SAVE_ERROR      = 'Data updation failed. ';  

export const MSG_TRAVEL_FIELD_ADD_SUCCESS  		= "Field added successfully.";
export const MSG_TRAVEL_FIELD_ADD_ERROR    		= "Field adding failed.";
export const MSG_TRAVEL_FIELD_MODIFY_SUCCESS  	= "Field updated successfully.";
export const MSG_TRAVEL_FIELD_MODIFY_ERROR   	= "Field updation failed.";
export const MSG_TRAVEL_FIELD_DELETE_SUCCESS  	= "Field deleted.";
export const MSG_TRAVEL_FIELD_DELETE_ERROR   	= "Field deletion failed.";

export const MSG_NOT_LOGGED_IN = 'Not logged in yet';

export const MSG_RATE_CARD_UPDATE_SUCCESS   = "Rate card updated";
export const MSG_RATE_CARD_UPDATE_ERROR     = "Rate card updation failed"; 

export const MSG_ACTIVITY_LOG_ERROR     = 'No records found.'; 

export const MSG_LOGO_FORMAT = "File formats supported .jpeg, .jpg, .png, .gif  (< 10MB)"

export const MSG_COMPANY_NAME_ADD_EDIT_DUPLICATE   = 'The following client(s) already exists in the system. Please add these clients manually so that you can verify and confirm the client details. ';
export const MSG_MAIL_RESEND = "We have resent the confirmation email to your email address. In order to complete the registration process, please click the confirmation link.";
export const MSG_MAIL_RESEND_ERROR = "Confirmation email sending failed.";
export const MSG_FOLLOWING_COMPANY_ALREADY_EXISTS = "The following client(s) already imported. ";
export const MSG_FOLLOWING_COMPANY_INVALID_PRIMARY_CONTACT = "The following client(s) have invalid primary contact details. ";
export const MSG_FOLLOWING_COMPANY_INVALID_CLIENT_DETAILS = "The following client(s) have invalid client details.";
export const MSG_FOLLOWING_CREW_INVALID_DETAILS = "The following crew(s) have invalid user details. ";

export const MSG_AVAILABILITY_STATUS  = 'Availability status changed to';

export const MSG_FILE_SIZE_ERROR = "File size should be less than 10mb.";
export const MSG_FILE_FORMAT_ERROR = "Not a supported format.";
export const MSG_FILE_NAME_ERROR = "Invalid file name.";
export const MSG_FILE_NAME_STRAT_WITH = "The filename should start with";

export const MSG_DOC_SAVE = "Document added.";
export const MSG_DOC_UPDATE = "Document updated.";
export const MSG_DOC_DELETE = "Document deleted.";
export const MSG_DOC_FILE_DELETE = "File deleted.";
export const MSG_DOC_UPLOAD = "File Uploaded."
export const MSG_DOC_EXIST = "This document already exists."
export const MSG_DOC_APPROVED = "Document has been Approved."
export const MSG_DOC_REJECTED = "Document has been Rejected."
export const MSG_DOC_ADD_ERROR = "Document adding failed.";
export const MSG_DOC_UPLOAD_ERROR = "Document uploading failed.";
export const MSG_DOC_UPDATION_ERROR = "Document updation failed.";
export const MSG_DOC_DELETE_ERROR = "Document deletion failed.";
export const MSG_DOC_STATUS_UPDATION_ERROR = "Document status updation failed.";

export const MSG_ASS_USER_ADD_SUCCESS    = 'Associate user added.'; 
export const MSG_ASS_USER_ADD_ERROR      = 'Sorry, associate user adding failed'; 
export const MSG_ASS_USER_UPDATE_SUCCESS = 'Associate user  details updated.'; 
export const MSG_ASS_USER_UPDATE_ERROR   = 'Sorry, associate user  details updation failed.'; 
export const MSG_ASS_USER_DELETE_SUCCESS = 'Associate user deleted.'; 
export const MSG_ASS_USER_DELETE_ERROR   = 'Sorry, Associate User deletion failed.';
export const MSG_ASS_USER_ACTIVATED_SUCCESS    = 'Associate user activated.'; 
export const MSG_ASS_USER_ACTIVATED_ERROR      = 'Sorry, associate user activation failed'; 

export const MSG_NOT_GENERATED  = "Not generated.";
export const MSG_QUOTE_UPDATE   = LBL_EVENT+" details has been updated.";
export const MSG_QUOTE_DELETE   = LBL_EVENT+" has been deleted.";
export const MSG_QUOTE_ACCEPTED   = "Quote has been accepted.";
export const MSG_QUOTE_REJECTED   = "Quote has been rejected.";
export const MSG_QUOTE_REQUESTED  = "Quote has been requested.";
export const MSG_QUOTE_CANCELLED  = LBL_EVENT+" has been cancelled.";  

export const MSG_SHIFT_ADDED        = "Shift has been added.";
export const MSG_QUOTE_MAIL_SEND    = "Quote has been sent to client.";
export const MSG_SHIFT_UPDATE       = "Shift has been updated.";
export const MSG_SHIFT_DELETE       = "Shift has been deleted.";
export const MSG_SHIFT_ADD_ERROR    = "Shift adding has been failed.";
export const MSG_SHIFT_UPDATE_ERROR = "Shift updation has been failed.";
export const MSG_SHIFT_UPDATE_PAST_TIME_ERROR = "Enter a valid shift start time. Shift time must be greater than current time.";

export const MSG_SHIFT_TOTAL_MSG = "Total";
export const MSG_SHIFT_REPEAT_ADDED = "shifts added to this "+LBL_EVENT+".";

export const MSG_SHIFT_QUICK_UPDATE_SUCCESS = "Quote has been updated.";
export const MSG_SHIFT_QUICK_UPDATE_ERROR   = "Quote Updation has been failed. ";

export const MSG_COMMON_FORM_ERROR = 'Please fill/check all required fields.'; 

export const MSG_START_END_DATE_VALIDATION = 'Please select end date greater than start date.'; 
export const MSG_REPEAT_SHIFT_VALIDATION = 'Please select week day between start and end date.'; 

export const MSG_SHIFT_NOT_FOUND    = "No shifts added yet.";
export const MSG_CREW_NOT_ACCEPTED  = stringFormat("No {0} has accepted this shift.",lblCrew);

export const MSG_SERVER_DATA_FETCH_ERROR = "Failed to fetch data from the server.";

export const MSG_QUOTE_MAIL_SEND_ERROR = "No shifts found.";

export const MSG_NOTIFICATION_READ_STATUS_ERROR = 'Notification read status failed.';

export const MSG_NOTIFICATION_ALL_MARK_AS_READ_ERROR = 'Mark as Read status updation failed.';
export const MSG_NOTIFICATION_ALL_MARK_AS_READ_SUCCESS = 'Mark as Read status updated.';

export const MSG_CREW_EMAIL_ALREADY_EXIST = stringFormat('The following {0} records are not imported since these emails are blank or  already exists in the system.',lblCrew.toLowerCase());  

export const MSG_CREW_SHIFT_STATUS_UPDATED    = stringFormat('{0} - shift status updated.',lblCrew);  
export const MSG_CREW_SHIFT_STATUS_ERROR      = 'Sorry, status updation failed.';  
export const MSG_CREW_SHIFT_FILLED            = 'Sorry, this shift has been filled already.';  

export const MSG_CREW_INFO_EMAIL_UPDATE = stringFormat('{0} basic Info has been updated. We have sent the confirmation email to the new email address. In order to complete the registration process, please click the confirmation link',lblCrew);

export const MSG_CREW_SHIFT_TIME_OVERLAP = 'Shift time is overlapping.';
export const MSG_CREW_SHIFT_NOT_FOUND = stringFormat('No matching {0} found for selected skills.',lblCrew);
export const MSG_CREW_SHIFT_NO_COMMON_SKILLS = 'No common skills are available in the selected shifts.';
export const MSG_TIMESHEET_UPDATED = "Timesheet updated.";
export const MSG_TIMESHEET_TOTAL_HOURS_LESS = "Total shift time should not be less than the check-in and check-out time difference.";

export const MSG_EVENT_NOT_EXISTS = LBL_EVENT+" does not exists.";
export const MSG_TIMEZONE_DATA_ERROR = "Failed to fetch timezone data from the server.";
export const MSG_CREW_AVAILABILITY_NOT_FOUND = stringFormat('No matching {0} found.',lblCrew);

export const MSG_PAST_SHIFT_SCHEDULE = "One or more selected shift(s) have already started/completed.";

export const MSG_FEEDBACK_UPDATED = "Feedback has been saved.";
export const MSG_FEEDBACK_RATING_UPDATED = "Thanks for rating.";
export const MSG_RATING = stringFormat("You have to rate the {0} in order to save feedback.",lblCrew);
export const MSG_SHIFT_CANCELLED = "Shift has been cancelled successfully.";
export const MSG_SHIFT_CANCEL_ERROR = "Shift cancellation failed. ";

export const MSG_CHIEF_COUNT_LESS = "{0} count should be less than or equal to skill "+stringFormat("{0} count.",lblCrew);

export const MSG_EVENT_LOC_DELETE_ERROR = "This record cannot be deleted. It has already been used in another module."; 

export const MSG_CREW_UNAVAILABLE = stringFormat("This {0} is unavailable for the selected shift(s).",lblCrew);
export const MSG_CREW_REQUESTED = stringFormat("This {0} has been already requested for the selected shift(s).",lblCrew);
export const MSG_CREW_FILLED = stringFormat("{0} members have been already filled for the selected shift(s)",lblCrew);
export const MSG_CREW_SKILL_FILLED = stringFormat("{0} members have been already filled for the selected skill.",lblCrew);
export const MSG_CHIEF_FILLED = "{0}(s) have been already filled for the selected shift(s).";
export const MSG_CHIEF_SKILL_FILLED = "{0}(s) have been already filled for the selected skill.";
export const MSG_CREW_TIMESLOT_FILLED = "You already have a shift scheduled on this timeslot.";
export const MSG_CREW_DEACTIVATED = stringFormat("This {0} has been deactivated on this affiliate account.",lblCrew);
export const MSG_CLIENT_DEACTIVATED = "This client has been deactivated on this affiliate account.";
export const MSG_SHIFT_CREW_DEPT_MISMATCH = stringFormat("Shift department is not available for the selected {0}.",lblCrew);

export const MSG_CONFIRM_SEND_QUOTE          = "Are you sure you want to send this quote to the client?";
export const MSG_CONFIRM_SEND_INVOICE        = "Are you sure you want to send this invoice to the client?";
                                         
export const MSG_SHIFT_SKILL_REMOVE_ERROR = stringFormat('The following skill(s) cannot be deleted because some {0} member(s) have already accepted the request - ',lblCrew); 
export const MSG_SHIFT_SKILL_EDIT_ERROR = stringFormat('You cannot update the {0} count with the given values for the skill(s), since {0} members are already accepted the shift request.',lblCrew,lblCrew); 
// 'You cannot update the crew count with the given values for the skill(s), since crew members are already accepted the shift request.';

export const NO_AVAILABILITY = "No unavailability entries today.";

export const MSG_SKILL_ZERO_ERROR = "At least one skill is mandatory for Shift."; 

export const MSG_SHIFT_DELETE_ERROR = stringFormat("Shift cannot be deleted because one or more {0} already accepted.",lblCrew)
export const MSG_SHIFT_TIME_UPDATE_ERROR = stringFormat("The shift time cannot be updated since the following {0} members are not available in the requested timeslot. ",lblCrew);

export const MSG_FOLLOWING_CONTACT_NOT_IMPORTED = "Following client contact are not imported:\n";
export const MSG_CLIENT_CONTACT_IMPORTED_SUCCESS = "Client contact imported successfully";
export const MSG_CLIENT_CONTACT_INVALID_DETAILS = "The following client contact(s) have invalid user details. ";

export const MSG_SHIFT_LENGTH_ERROR = "Shift length should be greater than 0."; 
export const MSG_MIN_SHIFT_LENGTH_ERROR = "Shift length should be greater than {0} hrs."; 
export const MSG_SHIFT_MAX_HOURS_ERROR = "Shift length should Not be greater than "+SHIFT_LENGTH_MAX_HRS; 
export const MSG_OT_MAX_HOURS_ERROR = "Over time hours should Not be greater than "+SHIFT_LENGTH_MAX_HRS; 

export const MSG_CREW_APPROVE_ERROR = stringFormat("This {0} induction is not complete. Induction is mandatory for {0} approval.",lblCrew,lblCrew);
export const MSG_CREW_INDUCTION_ERROR = "Induction status updation failed.";
export const MSG_CREW_CHIEF_APPROVE_ERROR = "Approval status updation failed.";

export const MSG_PAY_RATE_DELETE = "Are you sure you want to delete the AP Pay Rate?"; 

export const MSG_CHIEF_CHARGE_RATE_ERROR = "{0} pay pate should be Less than {1} charge rate/hr."; 

export const MSG_INVITE_AS_FRIEND_SUCCESS   = "Invitation sent successfully."; 
export const MSG_INVITE_AS_FRIEND_FAILED    = "Invitation sending failed."; 
export const MSG_INVITE_AS_FRIEND_ALREADY_REGISTER    = "This user is already registered."; 

export const MSG_PAY_LEVEL_ADD_SUCCESS      = "Pay level added.";
export const MSG_PAY_LEVEL_UPDATE_SUCCESS   = "Pay level updated.";
export const MSG_PAY_LEVEL_DELETE_SUCCESS   = "Pay level deleted.";

export const MSG_PAY_LEVEL_OMNU_ADD_SUCCESS      = LBL_APP_NAME+" points added against performance points.";
export const MSG_PAY_LEVEL_OMNU_UPDATE_SUCCESS   = LBL_APP_NAME+" points updated against performance points.";
export const MSG_PAY_LEVEL_OMNU_DELETE_SUCCESS   = LBL_APP_NAME+" points deleted against performance points.";

export const MSG_NO_INTERNET_ERROR   = "Network error. Check your internet connectivity.";

export const MSG_DATA_FETCH_CHIEF_BONUS_ERROR = "Failed to fetch {0} data from the server.";
export const MSG_DATA_UPDATE_CHIEF_BONUS_SUCCESS = "{0} rates modified successfully.";
export const MSG_DATA_UPDATE_CHIEF_BONUS_ERROR = "{0} rates updation failed.";

export const MSG_CREW_AVAILABILITY_ERROR   = stringFormat("You should review and approve the {0} profile in order to mark {0} as available.",lblCrew);

export const MSG_PROFILE_UPDATE_SUCCESS    = "Profile data updated successfully."
export const MSG_PROFILE_UPDATE_ERROR      = "Sorry, profile data updation failed."

export const MSG_EMAIL_EXISTS_ERROR        = "Email address already exists."

export const MSG_DATA_SAVE_ERROR           = 'Data updation failed.';  

export const MSG_ALL_CONTACTS_ALREADY_IMPORT   = "All the contacts in this file has been already imported."
export const MSG_CREW_IMPORT_SUCCESS   = stringFormat("{0} profiles imported successfully.",lblCrew); 

export const MSG_PAYLEVEL_UPDATE_ERROR   = "This pay level already exists.";
export const MSG_PAYLEVEL_DELETE_ERROR   = "This record cannot be deleted. It has already been used in another module.";

export const MSG_FILTER_COMMON_ERROR = 'Please select/enter any field.'; 

export const MSG_ROLE_DELETE_ERROR   = "This record cannot be deleted. It has already been used in another module.";

export const MSG_CREW_ACTIVATED      = stringFormat("{0} activated.",lblCrew); 


export const MSG_STATUS_UPDATED      = 'Status updated successfully.';

export const MSG_LOGIN_ERRORS        = {"invalid_credentials":"Invalid username or password.","user_not_found":"Invalid username or password.","user_suspended":"This user has been suspended. Please contact administrator.","common_error":"Sorry, unable to log in with the given credentials."};

export const MSG_EVENT_COMPLETE_SUCCESS = 'Status updated successfully.';
export const MSG_EVENT_COMPLETE_ERROR   = 'Status updation failed.';

export const MSG_DOCUMENT_DELETE_424_ERROR  = 'This record cannot be deleted. It has already been used in another module.';
export const MSG_DOCUMENT_DELETE_ERROR      = 'Document deletion failed.'; 

export const MSG_CREW_SHIFT_UNAVAILABLE     = "You have currently marked as unavailable on this time slot.";

export const MSG_CONFIRM_ACCEPT_QUOTE       = "Are you sure you want to accept this quote?";
export const MSG_CONFIRM_ACCEPT_QUOTE_AFLT  = "Are you sure you want to accept this quote on behalf of client?";

export const MSG_AFFILIATE_ADD_ERROR        = "Affiliate creation failed."; 

export const MSG_EVENT_ADD_ERROR            = LBL_EVENT+' adding failed.';

export const MSG_INVOICE_MAIL_SEND          = "Invoice has been sent to client primary contact";
export const MSG_INVOICE_MAIL_SEND_ERROR    = "Invoice sending failed.";
export const MSG_INVOICE_MAIL_SEND_ERR_CLIENT_EMAILS_MUTED = "Sending emails to this client is disabled,  Invoice sending failed.";
export const MSG_INVOICE_MAIL_SEND_ERR_ALL_CLIENTS_EMAIL_MUTED = "Sending emails to all clients are disabled,  Invoice sending failed."; 
export const MSG_MAIL_SEND_ERR_CLIENT_EMAILS_MUTED = "Sending emails to this client is disabled,  Email sending failed.";
export const MSG_MAIL_SEND_ERR_ALL_CLIENTS_EMAIL_MUTED = "Sending emails to all clients are disabled,  Email sending failed.";

export const MSG_SKILL_INDEX_UPDATE_ERROR   = 'Skill index updation failed.'; 

export const MSG_FORGOT_PWD_SUCCESS         = "We have sent the reset password email to the given email address. Please open this email from your inbox and click the reset password link, within 24 hrs.";
export const MSG_FORGOT_PWD_ERROR           = "Invalid username."; 
export const MSG_CREW_APPROVE_PAYLEVEL_ERROR= stringFormat("Pay level must be set before making {0} member active.",lblCrew); 

export const MSG_TIMESHEET_CSV_ERROR           = "Timesheet download failed."; 

export const MSG_PWD_RESET_SUCCESS          = "User verification email has been sent to user email id. This link is valid for 24 hrs only.";
export const MSG_DISCOUNT_VALID_ERROR       = "Discount value should be less than Sub total."; 

export const MSG_DISCOUNT_EDIT_SUCCESS      = "Discount updated."; 
export const MSG_DISCOUNT_EDIT_ERROR        = "Discount updation failed."; 
export const MSG_CSV_DOWNLOAD_ERROR         = "CSV download failed."; 
export const MSG_PDF_DOWNLOAD_ERROR         = "PDF download failed."; 

export const MSG_FIELD_LENGTH_128           = "Ensure this field has no more than 128 characters."; 
export const MSG_SHIFT_NO_DEPT_ERROR        = "Please select department for the folowing shift(s) before proceeding "; 
export const MSG_REMOVE_CREW_RELATED_SHIFT  = stringFormat("This is a multi shift "+LBL_EVENT.toLowerCase()+". Are you sure you want to remove the {0}",lblCrew)+" {0} from the following shifts: {1}?"; 
export const MSG_REMOVE_CREW_NORMAL_SHIFT  = stringFormat("Are you sure you want to remove {0}",lblCrew)+" {0} from shift: {1}?";
export const MSG_CONTINUE                  = " , Do you want to continue?"

export const MSG_CONFIRM_CLIENT_DEACTIVATE_START = "Are you sure you want to deactivate the client "; 
export const MSG_CONFIRM_CLIENT_DELETE_START = "Are you sure you want to delete the client "; 
export const MSG_CONFIRM_CLIENT_DELETE_END = " Client cannot login to the system once deleted.";

export const MSG_CONFIRM_CLIENT_ACTIVATE_START = "Are you sure you want to activate the client "; 
export const MSG_CONFIRM_CLIENT_CATEGORY = "Are you sure you want to modify the client category, this will adjust the rate card as well. Please confirm. "; 

export const MSG_RESEND_QUOTE_FOR_CLIENT_APPROVAL = "Shift details has updated and quote status has been changed. Please send the quote for client approval again."; // USED IN shiftAdd.js

export const MSG_PO_SIGN_REQ = " Please provide PO number or Signature.";

export const MSG_SECTOR_DELETE_424_ERROR = "This record cannot be deleted. It has already been used in another module.";  

export const MSG_CONFIRM_DATA_CHANGE_CLIENT ="You have just updated the client details. Do you want to save this?";
export const MSG_CONFIRM_DATA_CHANGE_RATE="You have just updated the rate card data. Do you want to save this?";
export const MSG_CONFIRM_DATA_CHANGE_DYNAMIC="You have just updated dynamic field data. Do you want to save this?";

export const MSG_DYN_FIELD_DUPLICATE_ENTRY = "Duplicate entry "; 

export const MSG_MASTER_RATE_CARD_SAVE = "Master rate card values are used to update the skill rates while creating a new client. For all existing clients, you have to set the rate card under the client settings."; 

export const MSG_SHIFT_TIME_CHANGE_ACCEPT_SUCCESS 	= 'Shift data updated successfully'; 
export const MSG_SHIFT_TIME_CHANGE_ACCEPT_FAILED 	= 'Data updation failed'; 
export const MSG_SHIFT_TIME_CHANGE_REJECT_FAILED 	= 'Data updation failed ';

export const MSG_MASTER_CARD_COPIED_SUCCESS = 'Rate card copied successfully';
export const MSG_CATEGORY_DATA_COPIED_SUCCESS = 'Category data copied successfully';

export const MSG_CATEGORY_MANDATORY_FIELD_MISSING = 'Client category field missing or mismatch for following companies : '; 

export const MSG_SHIFT_TIME_CHANGE_ACCEPT = stringFormat('Do you want to remove all the assigned {0} and send new shift request or send time change push notification only?',lblCrew); 

// export const MSG_DELETE_CLIENT_CATEGORY_1 = 'This action will remove the Master Rate Card values of Category {0}. '
export const MSG_DELETE_CLIENT_CATEGORY_2 = 'Are you sure you want to delete client category {0}?';

export const MSG_CATEGORY_DELETE_ERROR = 'This client category cannot be deleted since some of the clients are already listed under this category. Move the clients to any other category to delete this category.';
export const MSG_ACCEP_GOING_CANCELLED = 'This shift has already started/cancelled. You cannot accept any shift time change request now.';

export const MSG_SAVE_TIMESHEET_WITH_INVOICE_SENT = "You have updated the invoice. Since the invoice is already sent to customer, please regenerate  new invoice from Invoices tab.";
export const MSG_CONFIRM_REGEN_INVOICE            = "Are you sure you want to create & send a new invoice to the customer? This action will also void the previous invoice."
export const MSG_RECORDED_ADDED_SUCCESS 		  = 'Record added successfully';
export const MSG_RECORDED_DELETE_SUCCESS 		  = 'Record deleted successfully';
export const MSG_RECORDED_UPDATED_SUCCESS 		  = 'Record updated successfully';

export const MSG_VEHICLE_FIELD_ADD_ERROR 		  = 'Vehicle field adding failed';
export const MSG_VEHICLE_FIELD_UPDATE_ERROR 	  = 'Vehicle field modification failed';
export const MSG_VEHICLE_FIELD_DELETE_ERROR 	  = 'Vehicle field deletion failed';
export const MSG_VEHICLE_FIELD_DUP_ERROR          = 'Vehicle field is already added.';

export const MSG_NO_INPUT_PROVIDED 				  = 'No Input Provided';
export const MSG_DELETE_VECHICLE_FIELD  		  = 'Are you sure you want delete vehicle field {0}?';
export const MSG_DELETE_VECHICLE_DETAILS 		  = 'Are you sure you want delete the selected vehicle details?';
export const MSG_VEHICLE_DETAILS_UPDATED_SUCCESS  = 'Vehicle Info updated successfully';
export const MSG_VEHICLE_DETAILS_ADDED_SUCCESS    = 'Vehicle Info added successfully';
export const MSG_EMAIL_CHANGES_UPDATED    		  = 'Email changes updated';
export const MSG_PUSH_CHANGES_UPDATED     		  = 'Push notification changes updated';

export const MSG_CANCEL_REASONS_ADD_SUCCESS   		= 'Cancel reason added successfully.'; 
export const MSG_CANCEL_REASONS_ADD_FAILED    		= 'Cancel reason adding failed.'; 
export const MSG_CANCEL_REASONS_UPDATION_SUCCESS   	= 'Cancel reason modified successfully.'; 
export const MSG_CANCEL_REASONS_UPDATION_FAILED    	= 'Cancel reason modification failed.'; 
export const MSG_CANCEL_REASONS_DELETION_SUCCESS   	= 'Cancel reason deleted.'; 
export const MSG_CANCEL_REASONS_DELETION_FAILED    	= 'Cancel reason deletion failed.'; 
export const MSG_CONFIRM_CANCEL_REASONS_DELETE      = 'Are you sure you want to delete cancel reason {0}?';   
export const MSG_CANCEL_REASONS_DUPLICATE           = 'Cancel reason {0} already exists.';   
export const MSG_CANCEL_REASONS_LOAD_FAILED         = 'Cancel reason data loading failed.';   
export const MSG_CANCEL_EVENT_CONFIRM               = 'Are you sure you want to cancel/decline this '+LBL_EVENT.toLowerCase()+'? This action cannot be undone.';   

export const MSG_TERMS_FETCH_FAILED        		    = LBL_TERMS_AND_CONDITIONS+' data loading failed.'; 
export const MSG_TERMS_ADD_SUCCESS        		    = LBL_TERMS_AND_CONDITIONS+' added successfully.'; 
export const MSG_TERMS_ADD_FAILED        		    = LBL_TERMS_AND_CONDITIONS+' adding failed.'; 
export const MSG_TERMS_UPDATE_SUCCESS      		    = LBL_TERMS_AND_CONDITIONS+' modified successfully.'; 
export const MSG_TERMS_UPDATE_FAILED         	    = LBL_TERMS_AND_CONDITIONS+' modification failed.'; 
export const MSG_TERMS_ACCEPTED        		        = LBL_TERMS_AND_CONDITIONS+' accepted.'; 
export const MSG_TERMS_ACCEPT_ERROR    		        = LBL_TERMS_AND_CONDITIONS+' accept failed.'; 
export const MSG_TERMS_SELECT_ERROR    		        = 'Please select '+LBL_TERMS_AND_CONDITIONS; 

export const MSG_TERMS_DATA_EMPTY        		    = LBL_TERMS_AND_CONDITIONS+' cannot be empty.';

export const MSG_VALIDATION_ERROR_1        		    = 'At least 8 characters - the more characters, the better.'; 
export const MSG_VALIDATION_ERROR_2        		    = 'At least one uppercase and one lowercase letter.'; 
export const MSG_VALIDATION_ERROR_3        		    = 'At least one number character.'; 
export const MSG_VALIDATION_ERROR_4        		    = 'Inclusion of at least one special character, e.g., ! @ # ? ].';

export const MSG_ACTION_TAKEN_UPDATE_SUCCESS        = 'Action taken modified successfully.';  
export const MSG_ACTION_TAKEN_UPDATE_ERROR          = 'Action taken modification failed.';   
export const MSG_NO_DEPT_SKILL_SELECTED             = 'No departments/skills selected.';

export const MSG_UNAVAILABILITY_ADDED_SUCCESS       = 'Unavailability added successfully.';   
export const MSG_UNAVAILABILITY_DELETED_SUCCESS     = 'Unavailability deleted successfully.';   
export const MSG_UNAVAILABILITY_UPDATED_SUCCESS     = 'Unavailability updated successfully.';   
export const MSG_ALREADY_UNAVAIL_MARKED             = 'Already unavailability marked for the give time slot.';   
export const MSG_INVALID_TIME_SLOT                  = 'Invalid time slot provided.';   

export const MSG_DEPT_RATECARD_ERROR       		    = 'At least one department should have rate card.'; 
export const MSG_DEPT_RATECARD_UPDATE_SUCCESS	    = 'Rate card(s) updated';
export const MSG_DEPT_RATECARD_UPDATE_ERROR 	    = 'Rate card(s) updation failed';

export const MSG_FROM_SERVER = {
	rate_card_exists:MSG_RATECARD_ADD_EDIT_DUPLICATE,  
}; 

export const MSG_NOTES_ADD_SUCCESS       		= 'Crew notes added successfully.';  
export const MSG_NOTES_ADD_ERROR         		= 'Crew notes adding failed.'; 
export const MSG_NOTES_DOCUMENT_ADD_SUCCESS     = 'Crew notes document uploaded.';  
export const MSG_NOTES_DOCUMENT_ADD_ERROR       = 'Crew notes document upload failed.';  
export const MSG_NOTES_DOCUMENT_DELETE_SUCCESS  = 'Crew notes document deleted.';  
export const MSG_NOTES_DOCUMENT_DELETE_ERROR    = 'Crew notes document deletion failed.';  

export const MSG_ADD_MANDATORY_DATA             = 'Please add valid data in all mandatory fields.'; 

export const MSG_STAFF_FILTER_REQ_EVENT_SELECTION= 'Please select '+LBL_EVENTS.toLowerCase()+' for '+lblCrew+' filter.';  
export const MSG_SHIFT_STAFF_ASSIGNED_ERROR      = 'Staff already assinged on this day'; 
export const MSG_SHIFT_STAFF_SKILL_ERROR         = "Staff don't have required skill"; 

export const MSG_TM_FIELD_DELETE_MSG		= "Deleting this field will also remove it from all Affiliates, and this action cannot be undone."; 
export const MSG_TM_FIELD_DELETE_MSG2		= "Are you sure you want to delete the field '{0}'?"; 
export const MSG_TM_FIELD_ADD_DUPLICATE		= "Field name already exists, Field adding Failed.";


 
